import { CustomerStatus } from 'features/customer/store/types';
import useSubscriptionState from 'features/pricing/hook/useSubscriptionState';
import { useIsOnSalesAssistedPlan } from 'features/pricing/useIsOnSalesAssistedPlan';
import { useGetTeamMembers } from 'features/team/useGetTeamMembers';
import { useIsTeamOwnerOrAdmin } from 'features/team/useIsTeamOwnerOrAdmin';

export interface TeamInviteInfo {
  canInviteUser: boolean;
  seatsLeft: number;
  totalSeatsAvailable: number;
  totalTeamMemberCount: number;
  isTeamOwnerOrAdmin: boolean;
  isLoading: boolean;
  isSalesAssistedAccount: boolean;
}

export function useTeamInviteInfo(): TeamInviteInfo {
  const { currentSubscriptionState } = useSubscriptionState();
  const isTeamOwnerOrAdmin = useIsTeamOwnerOrAdmin();
  const { data: teamMembers, isLoading } = useGetTeamMembers({
    statuses: [CustomerStatus.ACTIVE],
  });
  const isSalesAssistedAccount = useIsOnSalesAssistedPlan();

  const totalTeamMemberCount = teamMembers?.total ?? 0;
  const totalSeatsAvailable = currentSubscriptionState?.availableSeats ?? 0;

  // Set isLoading to true if availableSeats is null or undefined
  const isSeatsAvailableLoading = currentSubscriptionState?.availableSeats == null;
  const effectiveIsLoading = isLoading || isSeatsAvailableLoading;

  const seatsLeft = Math.max(totalSeatsAvailable - totalTeamMemberCount, 0);

  let canInviteUser = true;
  if (isSalesAssistedAccount) {
    canInviteUser = seatsLeft > 0;
  } else {
    canInviteUser = isTeamOwnerOrAdmin;
  }

  return {
    canInviteUser,
    seatsLeft,
    totalSeatsAvailable,
    totalTeamMemberCount,
    isTeamOwnerOrAdmin,
    isLoading: effectiveIsLoading,
    isSalesAssistedAccount,
  };
}
